import type { VolleyballFixture } from '@ps/web-shared-generated-graphql/sports';

export const getVolleyballMatchScore = (
  previousSets: VolleyballFixture['previousSets'] | undefined
) =>
  previousSets?.reduce(
    (acc, set) => {
      if (!set) return acc;

      if (set.score.home > set.score.away) {
        acc.home += 1;
      } else if (set.score.away > set.score.home) {
        acc.away += 1;
      }
      return acc;
    },
    { home: 0, away: 0 }
  );
